import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, Button, Chip } from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useNotaCreditoStore } from '../store/notaCreditoStore';

export const NotasCreditoPage: React.FC = () => {
  const navigate = useNavigate();
  const { notas, loading, fetchNotas } = useNotaCreditoStore();

  useEffect(() => { fetchNotas(); }, [fetchNotas]);

  const columns: GridColDef[] = [
    { field: 'serie', headerName: 'Serie', width: 80 },
    { field: 'numero', headerName: 'Número', width: 100 },
    { field: 'fechaEmision', headerName: 'Fecha', width: 120, valueFormatter: (value: string) => { try { return format(new Date(value), 'dd/MM/yyyy', { locale: es }); } catch { return value; } } },
    { field: 'motivo', headerName: 'Motivo', flex: 1, minWidth: 200 },
    { field: 'tipoNotaCredito', headerName: 'Tipo', width: 100 },
    { field: 'total', headerName: 'Total', width: 120, type: 'number', valueFormatter: (value: number) => `S/ ${(value ?? 0).toFixed(2)}` },
    { field: 'estado', headerName: 'Estado', width: 100, renderCell: (params) => <Chip label={params.value || '-'} color={params.value === 'ACT' ? 'success' : 'default'} size="small" /> },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight="bold">Notas de Crédito</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/ventas/notas-credito/nueva')}>Nueva Nota de Crédito</Button>
      </Box>
      <Paper sx={{ height: 600 }}>
        <DataGrid rows={notas} columns={columns} getRowId={(row) => row.idNotaCredito} loading={loading}
          pageSizeOptions={[10, 20, 50]} initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          onRowClick={(params) => navigate(`/ventas/notas-credito/${params.row.idNotaCredito}`)}
          sx={{ cursor: 'pointer', border: 'none' }} disableRowSelectionOnClick />
      </Paper>
    </Box>
  );
};
